// extracted by mini-css-extract-plugin
export default {"goodsInfoBox":"goodsInfoBox_goodsInfoBox__2wjXn"};